import { apiClient } from '@/services/'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

export const namespaced = true

export const state = {
  loadingPage: false,
  loadingPageCount: 0,
  thisWeek: [],
  lastWeek: [],
  nextWeek: [],
}

export const mutations = {
  ADD_TO_LOADING_COUNT(state) {
    state.loadingPageCount += 1
    state.loadingPage = true
  },
  SUBTRACT_FROM_LOADING_COUNT(state) {
    state.loadingPageCount -= 1
    if (state.loadingPageCount == 0) {
      state.loadingPage = false
    }
  },
  SET_THIS_WEEK(state, status) {
    state.thisWeek = status
  },
  SET_LAST_WEEK(state, status) {
    state.lastWeek = status
  },
  SET_NEXT_WEEK(state, status) {
    state.nextWeek = status
  },
}

export const actions = {
  getDistanceLearning({ dispatch, getters, rootState }) {
    dispatch('getWeeklyData', rootState.thisMonday)
    dispatch('getWeeklyData', getters.lastMonday)
    dispatch('getWeeklyData', getters.nextMonday)
  },
  getWeeklyData({ commit, rootState, getters, state }, date) {
    commit('ADD_TO_LOADING_COUNT')
    return apiClient
      .get('/StudDistLearnSchedule', {
        params: {
          sAdName: rootState.adName,
          weekStartDateTime: date,
        },
      })
      .then((response) => {
        switch (date) {
          case getters.lastMonday:
            commit('SET_LAST_WEEK', response.data)
            break
          case getters.nextMonday:
            commit('SET_NEXT_WEEK', response.data)
            break
          default:
            commit('SET_THIS_WEEK', response.data)
        }
        commit('SUBTRACT_FROM_LOADING_COUNT')
        // Has distance learning - MN
        if (state.loadingPageCount === 0 && getters.allWeeks.length > 0) {
          rootState.userInfo.userRole.push(6)
        }
      })
  },
}

export const getters = {
  lastMonday(state, getters, rootState) {
    return dayjs(rootState.thisMonday).subtract(1, 'week').format('L')
  },
  nextMonday(state, getters, rootState) {
    return dayjs(rootState.thisMonday).add(1, 'week').format('L')
  },
  allWeeks(state) {
    return [...state.lastWeek, ...state.thisWeek, ...state.nextWeek]
  },
}
